module.exports = __webpack_public_path__ + "static/media/chia-work-5.b094dbc8.jpg";